import { render, staticRenderFns } from "./err.vue?vue&type=template&id=2a8fd854&"
import script from "./err.vue?vue&type=script&lang=js&"
export * from "./err.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports